import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allmessage',
  templateUrl: './allmessage.component.html',
  styleUrls: ['./allmessage.component.css']
})
export class AllmessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
